import ajax from '@/utils/request'
import utils from '../utils/'
import filters from '../filters'
import config from '../config'

export default {
  /**
   * 获取服务器时间
   */
  getTime () {
    const time = utils.storage.get('zxcvbnmtime')

    if (time && typeof time === 'number') {
      return Promise.resolve({time: filters.timestamp(time)})
    }

    return ajax({
      type: 'get',
      url: 'public/v1/misc/getTime'
    }).then(res => {
      return {
        time: filters.timestamp(res.time)
      }
    })
  },
  /**
   * 获取全部导航列表
   */
  getNavList () {
    return ajax({
      type: 'get',
      url: 'public/v1/config/getNav'
    })
  },
  /**
   * 初始化广告配置
   * @see https://yapi.geekbang.org/project/119/interface/api/6594
   */
  initAdvertising () {
    return ajax({
      host: config.adHost,
      type: 'get',
      url: 'public/serving/init'
    })
  },
  getPhoneList () {
    return ajax({
      host: config.account,
      type: 'get',
      url: 'account/cellphone/list'
    })
  },
  getAreaList () {
    return fetch(`${config.static001Host}files/resource/data/commonAreas.json?t=${Date.now()}`)
      .then(res => res.json())
  }
}
